import { useTranslation } from 'react-i18next';
import { Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 5rem;
`;

const StyledTitle = styled.div`
  margin: 2rem;
`;

export const AbortedSite = (): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledTitle>
        <Text bold appearance={TokenTextAppearance.headline300} data-testid="aborted-title">
          {t(`giveaway.aborted.title`)}
        </Text>
      </StyledTitle>
      <Text
        textAlign={TextAlignment.center}
        appearance={TokenTextAppearance.headline100}
        data-testid="aborted-message"
      >
        {t(`giveaway.aborted.message`)}
      </Text>
    </StyledContainer>
  );
};
